import { portalApi } from "./client";

// Owner Recapitalization Loan (letters.json popups → SignerMismatchWarning, OP4) —
// the signing step's signer check on a recap Conditional Approval letter:
//   GET /api/portal/items/{itemId}/signer-check
// `show` is true only at the caller's own Note Holder / Borrower stage of a recap
// letter when the signing account's name differs from the signer staff named. A
// warning only: signing is never blocked.

export interface LetterSignerCheckDto {
  show: boolean;
  name: string | null;
  title: string | null;
  entity: string | null;
}

export const letterSignerApi = {
  check: (itemId: string) => portalApi.get<LetterSignerCheckDto>(`/items/${itemId}/signer-check`),
};

/** The warning's copy, verbatim (letters.json popups). */
export function signerWarningCopy(check: LetterSignerCheckDto) {
  return {
    title: "Check the signer",
    body: `This letter names ${check.name ?? ""}, ${check.title ?? ""} as the signer for ${check.entity ?? ""}. If that is not you, return it with comments.`,
    returnLabel: "Return with comments",
    continueLabel: "Continue to sign",
  };
}
